export const generateHTMLContent = (pin: any, userDetails: any, token:any) => {
    return token ? `
      <html>
        <head>
          <title>PinPoint Details</title>
          <style>
            body {
              font-family: Arial, sans-serif;
              padding: 20px;
              color: #333;
            }
            .pdf-name h4, .pdf-name h5 {
              margin: 4px 0;
            }
            .pdf-address, .pdf-landmark {
              margin-top: 12px;
            }
            h4 {
              margin-bottom: 4px;
            }
            h5 {
              font-weight: normal;
              margin: 0;
            }
          </style>
        </head>
        <body>
          <div class="pdf-outer">
            <div class="bottom-container">
              <div class="pdf-name">
                <h4>${userDetails.name}</h4>
                <h5>${userDetails.username}</h5>
              </div>
  
              <div class="pdf-address">
                <h4>Address</h4>
                <h5>${pin.flat_details} ${pin.area},</h5>
                <h5>${pin.city}, ${pin.state}, ${pin.country}, ${pin.pin_code}</h5>
              </div>
  
              <div class="pdf-landmark">
                <h4>Landmark:</h4>
                <h5>${pin.landmark || "N/A"}</h5>
                ${
                  pin.map_link
                    ? `<h4>Map link:</h4><h5><a href="${pin.map_link}" target="_blank">${pin.map_link}</a></h5>`
                    : ""
                }
              </div>
            </div>
          </div>
        </body>
      </html>
    ` :  `
    <html>
      <head>
        <title>PinPoint Details</title>
        <style>
          body {
            font-family: Arial, sans-serif;
            padding: 20px;
            color: #333;
          }
          .pdf-name h4, .pdf-name h5 {
            margin: 4px 0;
          }
          .pdf-address, .pdf-landmark {
            margin-top: 12px;
          }
          h4 {
            margin-bottom: 4px;
          }
          h5 {
            font-weight: normal;
            margin: 0;
          }
        </style>
      </head>
      <body>
        <div class="pdf-outer">
          <div class="bottom-container">

            <div class="pdf-address">
              <h4>Address</h4>
              <h5>${pin.flat_details} ${pin.area},</h5>
              <h5>${pin.city}, ${pin.state}, ${pin.country}, ${pin.pin_code}</h5>
            </div>

            <div class="pdf-landmark">
              <h4>Landmark:</h4>
              <h5>${pin.landmark || "N/A"}</h5>
              ${
                pin.map_link
                  ? `<h4>Map link:</h4><h5><a href="${pin.map_link}" target="_blank">${pin.map_link}</a></h5>`
                  : ""
              }
            </div>
          </div>
        </div>
      </body>
    </html>
  `;
  };
  